import { sp, timing } from '@main/theme';
import { lighten } from 'polished';
import styled from 'styled-components';

/**
 * The wrapper for a form success
 */
export const SuccessWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  align-self: center;
  padding: ${sp(1.5)} ${sp(2)};
  width: fit-content;
  font-weight: 700;
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  color: ${({ theme }) => theme.colors.primary};
  margin-top: ${sp(2)};
  margin-right: auto;
  margin-left: auto;
`;

/**
 * The wrapper for a form error
 */
export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  padding: ${sp(2)};
  width: fit-content;
  border: ${({ theme }) => `solid 1px ${lighten(0.3, theme.colors.error)}`};
  border-radius: ${sp(0.75)};
  background: ${({ theme }) => lighten(0.4, theme.colors.error)};
  color: ${({ theme }) => theme.colors.error};
`;

/**
 * Padding top
 */
export const OuterErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${sp(2)};
`;

/**
 * The wrapper for the form button
 */
export const ButtonWrapper = styled.div`
  display: flex;
  width: fit-content;
  margin-top: ${sp(2)};
  border-radius: ${sp(0.75)};
  margin-right: auto;
  margin-left: auto;
`;

/**
 * Props for a label
 */
export interface LabelProps {
  /** Html input name */
  htmlInputName: string;
}

/**
 * The Label wrapper
 */
export const PcFormLabel = styled.label<LabelProps>`
  order: 1;
  transition: ${timing.shortEase('color')};
  color: ${({ theme }) => theme.colors.textLightOnBg};
  margin-bottom: ${sp(0.3)};
  font-weight: lighter;
  font-size: ${sp(1.6)};
  margin-left: ${sp(0.1)};
  ${({ htmlInputName }) => htmlInputName}:focus + & {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

/**
 * The Default Input wrapper
 */
export const PcFormInput = styled.input`
  order: 2;
  transition: ${timing.shortEase('border-color')};
  color: ${({ theme }) => theme.colors.textOnBg};
  display: block;
  width: 100%;
  padding: ${sp(1)};
  border-radius: ${sp(0.8)};
  border: 1px solid ${({ theme }) => lighten(0.53, theme.colors.textOnBg)};
  &:focus {
    border: 1px solid ${({ theme }) => lighten(0.15, theme.colors.primary)};
    outline: none;
  }
`;

/**
 * Text are props
 */
export interface TextAreaProps {
  /** Total number of lines */
  lines: number;
}

/**
 * The TextArea wrapper
 */
export const PcFormTextArea = styled.textarea<TextAreaProps>`
  order: 2;
  transition: ${timing.short} border-color ease;
  color: ${({ theme }) => theme.colors.textOnBg};
  display: block;
  width: 100%;
  line-height: 1.5em;
  min-height: ${({ lines }) => 1.5 * lines + 1.5}em;
  padding: ${sp(1)};
  border-radius: ${sp(0.8)};
  border: 1px solid ${({ theme }) => lighten(0.53, theme.colors.textOnBg)};
  &:focus {
    border: 1px solid ${({ theme }) => lighten(0.15, theme.colors.primary)};
    outline: none;
  }
`;

/**
 * The FormFields wrapper
 */
export const FormFieldsWrapper = styled.div`
  // Needed so that children can be ordered so that an adjacent selector can be used
  // w/ input:focus for the label.
  display: flex;
  flex-direction: column;
  margin-bottom: ${sp(1)};
`;
